export enum SmartChipType {
  ANALYSIS = 'ANALYSIS',
  ANALYSIS_TEMPLATE = 'ANALYSIS_TEMPLATE',
  AUTOMATION_OUTPUT_FILE = 'AUTOMATION_OUTPUT_FILE',
  BIOENTITY = 'BIOENTITY',
  BULK_ASSEMBLY = 'BULK_ASSEMBLY',
  CONNECTION = 'CONNECTION',
  DATASET = 'DATASET',
  DOCUMENT = 'DOCUMENT',
  ENTRY = 'ENTRY',
  FILE = 'FILE',
  PARTY = 'PARTY',
  PROCEDURE = 'PROCEDURE',
  PROCEDURE_METHOD_EXECUTION_INSTANCE = 'PROCEDURE_METHOD_EXECUTION_INSTANCE',
  PROCEDURE_RUN = 'PROCEDURE_RUN',
  PROCESS = 'PROCESS',
  PROCESS_OUTPUT = 'PROCESS_OUTPUT',
  PROCESS_TASK = 'PROCESS_TASK',
  REQUEST = 'REQUEST',
  REQUEST_V2_SUBMISSION = 'REQUEST_V2_SUBMISSION',
  RUN = 'RUN',
  RUN_SCHEMA = 'RUN_SCHEMA',
  SAMPLE_DEFINITION = 'SAMPLE_DEFINITION',
  STORABLE_SCHEMA = 'STORABLE_SCHEMA',
  STAGE_ENTRY = 'STAGE_ENTRY',
  STORABLE = 'STORABLE',
  STUDY = 'STUDY',
  TAG_SCHEMA = 'TAG_SCHEMA',
  TEMPLATE = 'TEMPLATE',
  TEST_DEFINITION = 'TEST_DEFINITION',
  TEST_ORDER = 'TEST_ORDER',
  WORKLIST = 'WORKLIST',
  WORKSHEET = 'WORKSHEET',
}
